import { memo } from 'react';
import { LottieContainer } from '@/sub-luca-plugin/compatible-components';
import './index.scss';
import { tCommon } from '@/sub-luca-plugin/i18n';

const CombineLoading = () => {
    return (
        <div className="combine-pictures-drawer-loading">
            <div className="combine-pictures-drawer-loading__content">
                <LottieContainer
                    className="combine-pictures-drawer-loading__lottie"
                    type="complexLoading"
                    excuteType="autoPlayByInit"
                    loop={true}
                />
                <span>{tCommon.t('recognizingImage', '图片识别中...')}</span>
            </div>
        </div>
    );
};

export default memo(CombineLoading);
